import icon1 from '../../assets/icons/fbs/Icon1.svg';
import icon2 from '../../assets/icons/fbs/Icon2.svg';
import icon3 from '../../assets/icons/fbs/Icon3.svg';
import icon4 from '../../assets/icons/fbs/Icon4.svg';
import icon5 from '../../assets/icons/fbs/Icon5.svg';
import icon6 from '../../assets/icons/fbs/Icon6.svg';
import icon7 from '../../assets/icons/fbs/Icon7.svg';
import icon8 from '../../assets/icons/fbs/Icon8.svg';
import icon9 from '../../assets/icons/fbs/Icon9.svg';
import icon10 from '../../assets/icons/fbs/Icon10.svg';
import { StripeProduct } from '../../api/subscription';
import { formatGBP, renderRhReferralPrice } from '../../utils/rhPromoPricing';
import { useRhReferralPricing } from '../../utils/useRhReferralPricing';

type LandingSectionProps = {
  onSelectScan: (scanType: 'lite' | 'full') => void;
  scanFullProduct: StripeProduct | null;
  scanLiteProduct: StripeProduct | null;
};

const LandingSection = ({ onSelectScan, scanFullProduct, scanLiteProduct }: LandingSectionProps) => {
    const referralPricingActive = useRhReferralPricing();

    const formatPrice = (product: StripeProduct | null, fallback: number): React.ReactNode => {
      const amount = product?.yearly_amount ?? fallback;
      if (referralPricingActive) {
        return renderRhReferralPrice({
          amount,
          kind: 'scan_plus',
          billingPeriod: 'once-off',
        });
      }
      return formatGBP(amount);
    };
    const selectScan = (scanType: 'lite' | 'full') => {
      onSelectScan(scanType);
      window.dataLayer.push({
        event: 'plan_selected',
        scan_type: scanType,
      });
    };

    return (
      <div className='landing-section-wrapper' >
        <h2 className='container-title'>Select a plan below</h2>
        <div className='plans-row' >
        <div className='inner-container' >
        
        <div className='mri-scan-card' >
          <div className='mri-scan-card-header' >
            <div>
              <h4>Scan Lite</h4>
              <p><span className='text1' >An MRI scan</span> <span className='text2' >excluding the spine</span></p>
            </div>
            <h4>{formatPrice(scanLiteProduct, 1250)}</h4>
          </div>
          <div className='mri-scan-card-content' >
            <div className='mri-scan-card-content-item' >
              <div className='icon-wrapper' >
                <img src={icon6} alt="" />
              </div>
              <div>GP consult included</div>
            </div>
            <div className='mri-scan-card-content-item' >
              <div className='icon-wrapper' >
                <img src={icon7} alt="" />
              </div>
              <div>60-90 minutes </div>
            </div>
            <div className='mri-scan-card-content-item' >
              <div className='icon-wrapper' >
                <img src={icon8} alt="" />
              </div>
              <div>Full-body screening</div>
            </div>
            <div className='mri-scan-card-content-item' >
              <div className='icon-wrapper' >
                <img src={icon9} alt="" />
              </div>
              <div>Free reschedule</div>
            </div>
          </div>
          <div className='mri-scan-includes' >
            <div className='mri-scan-includes-item' >
              <img src={icon1} alt="" />
              In-app full-body scan report
            </div>
            <div className='mri-scan-includes-item' >
              <img src={icon2} alt="" />
              Images received within 3 days
            </div>
            <div className='mri-scan-includes-item' >
              <img src={icon3} alt="" />
              Pre + post scan GP consults
            </div>
            <div className='mri-scan-includes-item' >
              <img src={icon4} alt="" />
              Report organised by body part 
            </div>
            <div className='mri-scan-includes-item disabled' >
              <img src={icon10} alt="" />
              Spine included 
            </div>
          </div>
          <button onClick={() => selectScan('lite')} className='black-btn'>Select Scan Lite</button>
        </div>
        </div>
        <div className='inner-container most-popular' >
        
        <div className='mri-scan-card ' >
          <div className='mri-scan-card-header' >
            <div>
              <h4>Scan</h4>
              <p><span className='text1' >An MRI scan</span> <span className='text2' >including the spine</span></p>
            </div>
            <h4>{formatPrice(scanFullProduct, 1650)}</h4>
          </div>
          <div className='mri-scan-card-content' >
            <div className='mri-scan-card-content-item' >
              <div className='icon-wrapper' >
                <img src={icon6} alt="" />
              </div>
              <div>GP consult included</div>
            </div>
            <div className='mri-scan-card-content-item' >
              <div className='icon-wrapper' >
                <img src={icon7} alt="" />
              </div>
              <div>60-90 minutes </div>
            </div>
            <div className='mri-scan-card-content-item' >
              <div className='icon-wrapper' >
                <img src={icon8} alt="" />
              </div>
              <div>Full-body screening</div>
            </div>
            <div className='mri-scan-card-content-item' >
              <div className='icon-wrapper' >
                <img src={icon9} alt="" />
              </div>
              <div>Free reschedule</div>
            </div>
          </div>
          <div className='mri-scan-includes' >
            <div className='mri-scan-includes-item' >
              <img src={icon1} alt="" />
              In-app full-body scan report
            </div>
            <div className='mri-scan-includes-item' >
              <img src={icon2} alt="" />
              Images received within 3 days
            </div>
            <div className='mri-scan-includes-item' >
              <img src={icon3} alt="" />
              Pre + post scan GP consults
            </div>
            <div className='mri-scan-includes-item' >
              <img src={icon4} alt="" />
              Report organised by body part 
            </div>
            <div className='mri-scan-includes-item active' >
              <img src={icon5} alt="" />
              Spine included 
            </div>
          </div>
          <button onClick={() => selectScan('full')} className='black-btn'>Select Scan</button>
        </div>
        </div>
        </div>
        
      </div>
    )
  }

  export default LandingSection;
